import { render, staticRenderFns } from "./RepairsTable.vue?vue&type=template&id=05706e8e&"
import script from "./RepairsTable.vue?vue&type=script&lang=js&"
export * from "./RepairsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports